module.exports = __webpack_public_path__ + "img/guanbi_bai.38b6880a.svg";